import React from "react";
import PublicPageLayout from "@/components/PublicPageLayout";
import Seo, { pageSchema } from "@/components/Seo";
import { WhatsAppButton } from "@/components/WhatsAppFab";
import { SampleDownloadCTA } from "@/components/SampleDownload";
import { WA_MESSAGES } from "@/lib/site";

export default function SampleData() {
  const path = "/sample-data";
  const title = "Sample Data | Preview MCA & GST Data Before Buying | Registry Feed";
  const description = "See a live sample of Registry Feed's MCA and GST company database before you buy. Verify email, download today's sample file, judge the data quality yourself.";
  const bc = [{ name: "Home", path: "/" }, { name: "Sample Data", path }];
  const jsonLd = pageSchema({ title, description, path, breadcrumbs: bc });
  return (
    <PublicPageLayout breadcrumbs={bc}>
      <Seo title={title} description={description} path={path} jsonLd={jsonLd} />
      <section className="mx-auto max-w-[1400px] px-4 sm:px-6 py-14 sm:py-20">
        <div className="max-w-3xl">
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight">See the data <span className="text-primary">before you buy</span>.</h1>
          <p className="mt-6 text-base sm:text-lg text-muted-foreground leading-relaxed">
            Request a free sample of today's newly registered companies. We'll send a 6-digit code to your email, and once you verify, you'll download up to 50 rows from today's fresh feed — pick GST, MCA or both, Pan India or a specific state.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <SampleDownloadCTA />
            <WhatsAppButton message={WA_MESSAGES.sample} label="Request via WhatsApp" testid="sample-page-wa" />
          </div>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[
            { t: "Verified email", d: "OTP is sent to your work email. This helps us keep the sample flow clean and abuse-free." },
            { t: "Real rows from today's file", d: "You see actual data from the same feed our paying subscribers get — not a scrubbed marketing PDF." },
            { t: "Limited size", d: "Samples are capped in rows and coverage. Full unlimited access requires a paid subscription." },
          ].map((x) => (
            <div key={x.t} className="rounded-lg border border-border bg-card p-5">
              <div className="font-heading font-semibold">{x.t}</div>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{x.d}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicPageLayout>
  );
}
